<template>


<div class="row" v-if="$gate.isAdmin()">

    <div class="toolbar py-6">
        <div class="container-fluid d-flex align-items-center">
            <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
                    <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
                        <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a></li>
                        <li class="breadcrumb-item pe-3 text-muted">Listă utilizatori</li>
                    </ol>
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
            </div>
        </div>
    </div>
		

    <div class="content d-flex flex-column flex-column-fluid">
        <div class="container-fluid">
            <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                    <div class="card-title">
                        <div class="d-flex align-items-center position-relative my-1">
                            Lista utilizatori
                        </div>
                    </div>
                    <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
                        <div class="input-group w-250px">
                            .
                        </div>
                        <div class="w-100 mw-150px">
                            .
                        </div>
                        <!-- <a class="btn btn-primary" @click="modalAdaugareFirma()">Adaugă firmă</a> -->
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div id="tabel_utilizatori_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="table-responsive w-100">
                          <table class="table table-striped table-row-bordered gy-5 gs-7 w-100" role="grid" id="tabel_utilizatori">
                            <thead>
                              <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                <th class="w-5px pe-2 sorting" rowspan="1" colspan="1" aria-label="" style="width: 10.8906px;"></th>
                                <th class="min-w-10px sorting" tabindex="0" aria-controls="tabel_utilizatori" rowspan="1" colspan="1" aria-label="ID: apasa pentru sortare">ID</th>
                                <th class="min-w-175px sorting" tabindex="0" aria-controls="tabel_utilizatori" rowspan="1" colspan="1" aria-label="Utilizator: apasa pentru sortare">Utilizator</th>
                                <th class="min-w-50px sorting" tabindex="0" aria-controls="tabel_utilizatori" rowspan="1" colspan="1" aria-label="Rol: apasa pentru sortare">Rol</th>
                                <th class="min-w-125px sorting" tabindex="0" aria-controls="tabel_utilizatori" rowspan="1" colspan="1" aria-label="Firma: apasa pentru sortare">Firmă</th>
                                <th class="d-none">__search_firme__</th>
                                <th class="min-w-50px sorting" tabindex="0" aria-controls="tabel_utilizatori" rowspan="1" colspan="1" aria-label="Activ: apasa pentru sortare">Activ</th>
                                <th class="text-end min-w-150px sorting" tabindex="0" aria-controls="tabel_utilizatori" rowspan="1" colspan="1" aria-label="Creat / Modificat: apasa pentru sortare">Creat / Modificat</th>
                                <th class="text-end min-w-100px" tabindex="0" rowspan="1" colspan="1" aria-label="Actiuni">Acțiuni</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="u in utilizatori" :key="u.id">
                                <td>
                                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                                    <input class="form-check-input" type="checkbox" :value="u.id">
                                  </div>
                                </td>
                                <td data-kt-ecommerce-order-filter="order_id">
                                  <a class="text-gray-800 text-hover-primary fw-bold">{{ u.id }}</a>
                                </td>
                                <td>
                                  <div class="d-flex align-items-center">
                                    <div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                      <div v-if="u.avatar" class="symbol-label">
                                        <img :src="`/api/fisiere/avatar-utilizator/${u.id}`" alt="Avatar" style="width: 100%; height: 100%; object-fit: cover;" />
                                      </div>
                                      <div v-else :class="avatarClass(u)">{{ (u.name || '?').charAt(0) }}</div>
                                    </div>
                                    <div class="ms-5">
                                      <div class="ml-2">
                                        <div class="text-dark-75 font-weight-bold line-height-sm">
                                          <span class="fw-bold">{{ u.name }}</span>
                                        </div>
                                        <a class="font-size-sm text-dark-50 text-hover-primary">{{ u.email }}</a>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td class="pe-0">
                                  <template v-if="u.roles && u.roles.length">
                                    <span v-for="r in u.roles" :key="r" :class="badgeClassForRole(r)" class="me-1">{{ r }}</span>
                                  </template>
                                  <template v-else>
                                    <span class="badge badge-light">—</span>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="u.firme_count === 1">
                                    <span class="fw-bold">{{ (u.firma && u.firma.denumire) ? u.firma.denumire : (u.firme_list && u.firme_list.length ? u.firme_list[0].denumire : '—') }}</span>
                                  </template>
                                  <template v-else-if="u.firme_count > 1">
                                    <span class="fw-bold">{{ u.firme_count }} firme</span>
                                  </template>
                                  <template v-else>
                                    <span class="fw-bold">—</span>
                                  </template>
                                </td>
                                <td class="d-none">
                                  {{ (u.firme_list || []).map(f => `${f.denumire} ${f.cui}`).join(' ') }}
                                </td>
                                <td>
                                  <span class="fw-bold">
                                    <span class="font-weight-bold text-success" v-if="u.activ == 1 || u.activ === true">Da</span>
                                    <span class="font-weight-bold text-danger" v-else>Nu</span>
                                  </span>
                                </td>
                                <td class="text-end">
                                  <div class="d-flex flex-column align-items-end">
                                    <div>
                                      <span class="text-muted me-2">Creat:</span>
                                      <span class="fw-bold">{{ $filters.formatDate ? $filters.formatDate(u.created_at) : u.created_at }}</span>
                                    </div>
                                    <div>
                                      <span class="text-muted me-2">Modif.:</span>
                                      <span class="fw-bold">{{ u.updated_at ? ($filters.formatDate ? $filters.formatDate(u.updated_at) : u.updated_at) : '-' }}</span>
                                    </div>
                                  </div>
                                </td>
                                <td class="text-end">
                                  <button class="btn btn-sm btn-light-warning me-2" @click="editeazaUtilizator(u)">
                                    <i class="fas fa-pencil-alt"></i> Editare
                                  </button>
                                  <button class="btn btn-sm btn-light-info me-2" @click="veziFirme(u)" :disabled="!u.firme_count">
                                    <i class="fas fa-building"></i> Firme
                                  </button>
                                  <button class="btn btn-sm" :class="u.activ ? 'btn-light-danger' : 'btn-light-success'" @click="toggleActiv(u)">
                                    <i class="fa" :class="u.activ ? 'fa-ban' : 'fa-check'"></i>
                                    Activ
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 

  <!-- Modal Editare Utilizator -->
  <div class="modal fade" id="UtilizatorModal" role="dialog" aria-labelledby="UtilizatorModalLabel" aria-hidden="true" ref="modalUtilizator">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="UtilizatorModalLabel">Editează utilizator</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form onsubmit="return false;">
            <div class="row g-5">
              <div class="col-md-6">
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="nume" v-model="form.nume"/>
                  <label for="nume">Nume</label>
                </div>
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="prenume" v-model="form.prenume"/>
                  <label for="prenume">Prenume</label>
                </div>
                <div class="form-floating mb-3">
                  <input type="email" class="form-control" id="email" v-model="form.email"/>
                  <label for="email">Email</label>
                </div>
                <div class="form-floating mb-3">
                  <input type="password" class="form-control" id="password" v-model="form.password" placeholder="(lasă gol dacă nu schimbi)"/>
                  <label for="password">Parolă (opțional)</label>
                </div>
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="telefon" v-model="form.telefon"/>
                  <label for="telefon">Telefon</label>
                </div>
                <div class="form-floating mb-3">
                  <input type="text" class="form-control" id="cnp" v-model="form.cnp"/>
                  <label for="cnp">CNP</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-floating mb-3">
                  <textarea class="form-control" id="firme" style="height: 100px" v-model="form.firme" placeholder="[ID1-Drepturi], [ID2-Drepturi]"></textarea>
                  <label for="firme">Firme (format: [ID-Drepturi])</label>
                </div>
                <div class="row g-3 mb-3">
                  <div class="col">
                    <div class="form-floating">
                      <select class="form-select" id="firma_curenta" v-model.number="form.firma_curenta">
                        <option :value="null">— Neselectat —</option>
                        <option v-for="opt in form_firme_options" :key="`fc-`+opt.id" :value="opt.id">
                          {{ opt.denumire }} ({{ opt.cui }}) — ID: {{ opt.id }}
                        </option>
                      </select>
                      <label for="firma_curenta">Firma curentă</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-floating">
                      <select class="form-select" id="autologin_firma" v-model.number="form.autologin_firma">
                        <option :value="null">— Neselectat —</option>
                        <option v-for="opt in form_firme_options" :key="`al-`+opt.id" :value="opt.id">
                          {{ opt.denumire }} ({{ opt.cui }}) — ID: {{ opt.id }}
                        </option>
                      </select>
                      <label for="autologin_firma">Autologin firmă</label>
                    </div>
                  </div>
                </div>
                <div class="row g-3 mb-3">
                  <div class="col">
                    <div class="form-floating">
                      <select class="form-select" id="tip_cont" v-model.number="form.tip_cont">
                        <option :value="1">Utilizator</option>
                        <option :value="10">Administrator</option>
                        <option :value="996">Webdev</option>
                      </select>
                      <label for="tip_cont">Tip cont</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-floating">
                      <input type="text" class="form-control" id="ip_inregistrare" v-model="form.ip_inregistrare" disabled/>
                      <label for="ip_inregistrare">IP înregistrare</label>
                    </div>
                  </div>
                </div>
                <div class="row g-3 mb-3">
                  <div class="col-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="activ" v-model="form.activ">
                      <label class="form-check-label" for="activ">Activ</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="newsletter" v-model="form.newsletter">
                      <label class="form-check-label" for="newsletter">Newsletter</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="is_email_verified" v-model="form.is_email_verified">
                      <label class="form-check-label" for="is_email_verified">Email verificat</label>
                    </div>
                  </div>
                </div>
                <div class="form-floating mb-3">
                  <input type="datetime-local" class="form-control" id="email_verified_at" v-model="form.email_verified_at" readonly />
                  <label for="email_verified_at">Email verificat la</label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Închide</button>
          <button type="button" class="btn btn-success" @click="salveazaUtilizator">Salvează</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Firme Utilizator -->
<div class="modal fade" id="FirmeModal" role="dialog" aria-labelledby="FirmeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title d-flex align-items-center gap-2" id="FirmeModalLabel">
          <i class="fas fa-building"></i>
          Firme utilizator
        </h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div v-if="firmeViz_list && firmeViz_list.length">
          <div class="list-group list-group-flush">
            <a v-for="f in firmeViz_list" :key="f.id" class="list-group-item list-group-item-action py-4 d-flex align-items-center justify-content-between firme-item">
              <div class="d-flex align-items-center gap-3">
                <div class="symbol symbol-circle symbol-40px bg-light d-flex align-items-center justify-content-center">
                  <i class="fas fa-industry"></i>
                </div>
                <div class="d-flex flex-column">
                  <div class="fw-bold">{{ f.denumire }}</div>
                  <div class="text-muted small">CUI: {{ f.cui }} · ID: {{ f.id }}</div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-3">
                <span :class="firmRoleBadgeClass(f.drepturi)" class="badge">{{ firmRoleLabel(f.drepturi) }}</span>
              </div>
            </a>
          </div>
        </div>
        <div v-else class="text-muted">Nicio firmă asociată.</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Închide</button>
      </div>
    </div>
  </div>
</div>
</template>


<script>
    
    import moment from "moment";
    //import vue2Dropzone from 'vue2-dropzone'
    //import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    //import VueDatepickerUi from 'vue-datepicker-ui'
    //import 'vue-datepicker-ui/lib/vuedatepickerui.css';
    

    
    import Form from 'vform'
    export default {
          components: {
            moment: moment,
          },
    data () {
        return {
            setari_select2: {
                theme: 'bootstrap-5',
                placeholder: "Selectează din listă",
                width: "100%",
                dropdownParent: null
            },
            utilizatori: [],
            form: Form.make({
              id: '',
              email: '',
              password: '',
              nume: '',
              prenume: '',
              cnp: '',
              telefon: '',
              firme: '',
              firma_curenta: null,
              autologin_firma: null,
              tip_cont: 1,
              newsletter: false,
              ip_inregistrare: '',
              activ: true,
              is_email_verified: false,
              email_verified_at: ''
            }),
            editmode: false,
            firmeViz_user: null,
            firmeViz_list: [],
            form_firme_options: [],
        }
    },
    methods: {
      badgeClassForRole(r) {
        const role = (r || '').toString().toLowerCase();
        if (role === 'administrator') return 'badge badge-light-danger badge-role'; // rosu + marit
        if (role === 'webdev') return 'badge badge-light-dark badge-role'; // negru + marit
        return 'badge badge-light-primary badge-role'; // albastru + marit
      },
      firmRoleLabel(drepturi) {
        const d = Number(drepturi || 0);
        if (d >= 5) return 'Deținător';
        if (d === 4) return 'Administrator';
        if (d === 3) return 'Editor';
        if (d === 2) return 'Operator';
        if (d === 1) return 'Vizualizare';
        return '—';
      },
      firmRoleBadgeClass(drepturi) {
        const d = Number(drepturi || 0);
        if (d >= 5) return 'badge-light-success';
        if (d === 4) return 'badge-light-danger';
        if (d === 3) return 'badge-light-info';
        if (d === 2) return 'badge-light-warning';
        if (d === 1) return 'badge-light-secondary';
        return 'badge-light';
      },
      avatarClass(u) {
        // Deterministic color based on user id/email/name
        const seedStr = (u && (u.id?.toString() || u.email || u.name || 'x')).toString();
        let hash = 0;
        for (let i = 0; i < seedStr.length; i++) {
          hash = ((hash << 5) - hash) + seedStr.charCodeAt(i);
          hash |= 0; // to 32bit
        }
        const palette = ['primary', 'success', 'info', 'warning', 'danger', 'dark', 'secondary'];
        const color = palette[Math.abs(hash) % palette.length];
        // Use Metronic/Bootstrap utility classes for light bg + colored text
        return [`symbol-label`, `fs-3`, `bg-light-${color}`, `text-${color}`];
      },
      async incarcaUtilizatori() {
        axios.get('/api/administrare/utilizatori')
          .then((response) => {
            this.utilizatori = response.data.utilizatori || response.data || [];
            $(document).ready(function () {
              $('#tabel_utilizatori').DataTable().destroy();
              $('#tabel_utilizatori').DataTable({
                order: [[1, 'desc']], // sortare dupa ID
                dom: 'Bfrtip',
                buttons:['disable'],
                columnDefs: [
                  { targets: [5], visible: false, searchable: true }, // coloana ascunsă cu denumiri+CUI pentru căutare
                ],
                language: {
                  url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json'
                }
              });
            });
          });
      },
      editeazaUtilizator(u) {
        this.editmode = true;
        this.form.reset();
        this.form_firme_options = Array.isArray(u.firme_list) ? u.firme_list.map(f => ({ id: f.id, denumire: f.denumire, cui: f.cui })) : [];
        this.form.fill({
          id: u.id,
          email: u.email,
          password: '',
          nume: (u.name || '').split(' ')[0] || '',
          prenume: (u.name || '').split(' ').slice(1).join(' ') || '',
          cnp: u.cnp || '',
          telefon: u.telefon || '',
          firme: u.firme || '',
          firma_curenta: u.firma_curenta || null,
          autologin_firma: u.autologin_firma || null,
          tip_cont: u.tip_cont || 1,
          newsletter: !!u.newsletter,
          ip_inregistrare: u.ip_inregistrare || '',
          activ: !!u.activ,
          is_email_verified: !!u.is_email_verified,
          email_verified_at: u.email_verified_at ? u.email_verified_at.replace(' ', 'T') : ''
        });
        $('#UtilizatorModal').modal('show');
      },
      veziFirme(u) {
        this.firmeViz_user = u;
        this.firmeViz_list = Array.isArray(u.firme_list) ? u.firme_list : [];
        $('#FirmeModal').modal('show');
      },
      async toggleActiv(u) {
        try {
          const nou = !(u.activ == 1 || u.activ === true)
          await axios.put(`/api/administrare/utilizatori/${u.id}`, { activ: nou })
          u.activ = nou
          toast.fire({ icon: 'success', title: nou ? 'Utilizator activat' : 'Utilizator dezactivat' })
        } catch (e) {
          console.error(e)
          toast.fire({ icon: 'error', title: 'Eroare la schimbarea stării' })
        }
      },
      salveazaUtilizator() {
        if (!this.form.id) return;

        // Normalizăm câmpurile ca să treacă validările din backend
        const wasPasswordEmpty = !this.form.password; // evităm min:8 când nu vrem să schimbăm parola
        this.form.password = wasPasswordEmpty ? null : this.form.password;
        this.form.newsletter = this.form.newsletter ? 1 : 0; // backend așteaptă integer (0/1)
        this.form.activ = !!this.form.activ; // boolean
        this.form.is_email_verified = !!this.form.is_email_verified; // boolean
        this.form.tip_cont = Number(this.form.tip_cont) || 1; // integer
        this.form.email_verified_at = this.form.email_verified_at ? this.form.email_verified_at : null; // date sau null

        this.$Progress && this.$Progress.start && this.$Progress.start();
        this.form.post(`/api/administrare/utilizatori/${this.form.id}?_method=PUT`)
          .then((response) => {
            toast.fire({ icon: 'success', title: 'Utilizator salvat' });
            $('#UtilizatorModal').modal('hide');
            emitter && emitter.emit && emitter.emit('AfterCreate');
            this.$Progress && this.$Progress.finish && this.$Progress.finish();
          })
          .catch((e) => {
            console.error(e);
            toast.fire({ icon: 'error', title: 'Eroare la salvare' });
            this.$Progress && this.$Progress.fail && this.$Progress.fail();
          })
          .finally(() => {
            // revenim cu parola vizuală goală în formular
            if (wasPasswordEmpty) this.form.password = '';
          });
      }
    },
    computed: {
    },

    created(){
      this.incarcaUtilizatori();
      emitter.on('AfterCreate', () => {
        this.incarcaUtilizatori();
      });
    },
    
    }
    </script>
    
    
    <style lang="scss" scoped>
    .icon-mare {
        font-size: 24px
    }

    .modal-custom-width {
        max-width: 85% !important;
    }


.badge-role {
  font-size: 1rem;      /* mai mare decât default */
  padding: 0.45rem 0.6rem; /* mai lat și mai înalt */
  line-height: 1;          /* compact */
  border-radius: 0.5rem;   /* colțuri un pic mai rotunjite */
}

    .firme-item {
      transition: background-color .15s ease, box-shadow .15s ease;
    }
    .firme-item:hover {
      background-color: rgba(0,0,0,0.02);
      box-shadow: 0 2px 6px rgba(0,0,0,.06);
    }
    </style>